<div class="flex h-[200px] flex-col items-center justify-center">
  <div class="flex">
    <m-avatar
      [avatar]="dataItem.avatar"
      [initials]="dataItem.initials"
    ></m-avatar>
  </div>
</div>
